import { Autocomplete, BlockStack, Box, Button, Card, Collapsible, Icon, InlineStack, Layout, Modal, Page, SkeletonBodyText, SkeletonDisplayText, Tag, Text, TextField } from '@shopify/polaris';
import { ChevronDownMinor, SearchMinor, ThumbsDownMinor, ThumbsUpMinor } from '@shopify/polaris-icons';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import './style.css';

const KnowledgeBaseSkeleton = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1071); // set the breakpoint at 768px
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // check the initial size
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <BlockStack gap="400">
            <Card roundedAbove='sm'>
                <BlockStack gap="400">
                    <Text variant="headingMd" as="h6">
                        How can we help you?
                    </Text>
                    <div className='skeleton--textfield'>
                        <SkeletonDisplayText />
                    </div>
                </BlockStack>
            </Card>
            <Card roundedAbove='sm'>
                <BlockStack gap="800">
                    <Text variant="headingMd" as="h6">
                        Browse Category
                    </Text>
                    <Layout>
                        <Layout.Section variant="oneThird">
                            <div>
                                <BlockStack gap="200">
                                    <div className='Custom__Box--FirstStep'>
                                        <Box padding="500">
                                            <div style={{ cursor: 'pointer' }}>
                                                <InlineStack align='space-between' blockAlign='center' gap='400'>
                                                    <div className='skeleton--button'>
                                                        <SkeletonDisplayText size='small' />
                                                    </div>
                                                    <div>
                                                        <Icon
                                                            source={ChevronDownMinor}
                                                            tone="base"
                                                        />
                                                    </div>
                                                </InlineStack>
                                            </div>
                                        </Box>
                                    </div>
                                </BlockStack>

                                <BlockStack gap="200">
                                    <div className='Custom__Box--FirstStep'>
                                        <Box padding="500">
                                            <div style={{ cursor: 'pointer' }}>
                                                <InlineStack align='space-between' blockAlign='center' gap='400'>
                                                    <div className='skeleton--button'>
                                                        <SkeletonDisplayText size='small' />
                                                    </div>
                                                    <div>
                                                        <Icon
                                                            source={ChevronDownMinor}
                                                            tone="base"
                                                        />
                                                    </div>
                                                </InlineStack>
                                            </div>
                                        </Box>
                                    </div>
                                </BlockStack>
                                <BlockStack gap="200">
                                    <div className='Custom__Box--FirstStep'>
                                        <Box padding="500">
                                            <div style={{ cursor: 'pointer' }}>
                                                <InlineStack align='space-between' blockAlign='center' gap='400'>
                                                    <div className='skeleton--button'>
                                                        <SkeletonDisplayText size='small' />
                                                    </div>
                                                    <div>
                                                        <Icon
                                                            source={ChevronDownMinor}
                                                            tone="base"
                                                        />
                                                    </div>
                                                </InlineStack>
                                            </div>
                                        </Box>
                                    </div>
                                </BlockStack>
                                <BlockStack gap="200">
                                    <div className='Custom__Box--FirstStep'>
                                        <Box padding="500">
                                            <div style={{ cursor: 'pointer' }}>
                                                <InlineStack align='space-between' blockAlign='center' gap='400'>
                                                    <div className='skeleton--button'>
                                                        <SkeletonDisplayText size='small' />
                                                    </div>
                                                    <div>
                                                        <Icon
                                                            source={ChevronDownMinor}
                                                            tone="base"
                                                        />
                                                    </div>
                                                </InlineStack>
                                            </div>
                                        </Box>
                                    </div>
                                </BlockStack>
                                <BlockStack gap="200">
                                    <div className='Custom__Box--FirstStep'>
                                        <Box padding="500">
                                            <div style={{ cursor: 'pointer' }}>
                                                <InlineStack align='space-between' blockAlign='center' gap='400'>
                                                    <div className='skeleton--button'>
                                                        <SkeletonDisplayText size='small' />
                                                    </div>
                                                    <div>
                                                        <Icon
                                                            source={ChevronDownMinor}
                                                            tone="base"
                                                        />
                                                    </div>
                                                </InlineStack>
                                            </div>
                                        </Box>
                                    </div>
                                </BlockStack>
                                <BlockStack gap="200">
                                    <div className='Custom__Box--FirstStep'>
                                        <Box padding="500">
                                            <div style={{ cursor: 'pointer' }}>
                                                <InlineStack align='space-between' blockAlign='center' gap='400'>
                                                    <div className='skeleton--button'>
                                                        <SkeletonDisplayText size='small' />
                                                    </div>
                                                    <div>
                                                        <Icon
                                                            source={ChevronDownMinor}
                                                            tone="base"
                                                        />
                                                    </div>
                                                </InlineStack>
                                            </div>
                                        </Box>
                                    </div>
                                </BlockStack>
                            </div>
                        </Layout.Section>
                        <Layout.Section >
                            {!isMobile && <BlockStack gap="500">

                                <Card>
                                    <BlockStack gap="500">
                                        <div className='skeleton--textfield'>
                                            <SkeletonDisplayText />
                                        </div>
                                        <SkeletonBodyText lines={20} />
                                    </BlockStack>
                                </Card>

                                <Card>
                                    <BlockStack gap="400">
                                        <div className='skeleton--textfield'>
                                            <SkeletonDisplayText />
                                        </div>
                                        <div className='skeleton--textfield'>
                                            <SkeletonDisplayText />
                                        </div>
                                        <InlineStack align='end'>
                                            <div className='skeleton--button' style={{ flex: 'unset' }}>
                                                <SkeletonDisplayText />
                                            </div>
                                        </InlineStack>
                                    </BlockStack>
                                </Card>
                            </BlockStack>}
                        </Layout.Section>
                    </Layout>
                </BlockStack>
            </Card>
        </BlockStack >
    );
}

export default KnowledgeBaseSkeleton;

export const ChildKnowledgeBaseSekleton = () => {
    return <div>
        <BlockStack gap="200">
            <div className='Custom__Box--FirstStep'>
                <Box padding="500">
                    <div style={{ cursor: 'pointer' }}>
                        <InlineStack align='space-between' blockAlign='center' gap='400'>
                            <div className='skeleton--button'>
                                <SkeletonDisplayText size='small' />
                            </div>
                            <div>
                                <Icon
                                    source={ChevronDownMinor}
                                    tone="base"
                                />
                            </div>
                        </InlineStack>
                    </div>
                </Box>
            </div>
        </BlockStack>

        <BlockStack gap="200">
            <div className='Custom__Box--FirstStep'>
                <Box padding="500">
                    <div style={{ cursor: 'pointer' }}>
                        <InlineStack align='space-between' blockAlign='center' gap='400'>
                            <div className='skeleton--button'>
                                <SkeletonDisplayText size='small' />
                            </div>
                            <div>
                                <Icon
                                    source={ChevronDownMinor}
                                    tone="base"
                                />
                            </div>
                        </InlineStack>
                    </div>
                </Box>
            </div>
        </BlockStack>
        <BlockStack gap="200">
            <div className='Custom__Box--FirstStep'>
                <Box padding="500">
                    <div style={{ cursor: 'pointer' }}>
                        <InlineStack align='space-between' blockAlign='center' gap='400'>
                            <div className='skeleton--button'>
                                <SkeletonDisplayText size='small' />
                            </div>
                            <div>
                                <Icon
                                    source={ChevronDownMinor}
                                    tone="base"
                                />
                            </div>
                        </InlineStack>
                    </div>
                </Box>
            </div>
        </BlockStack>
        <BlockStack gap="200">
            <div className='Custom__Box--FirstStep'>
                <Box padding="500">
                    <div style={{ cursor: 'pointer' }}>
                        <InlineStack align='space-between' blockAlign='center' gap='400'>
                            <div className='skeleton--button'>
                                <SkeletonDisplayText size='small' />
                            </div>
                            <div>
                                <Icon
                                    source={ChevronDownMinor}
                                    tone="base"
                                />
                            </div>
                        </InlineStack>
                    </div>
                </Box>
            </div>
        </BlockStack>
        <BlockStack gap="200">
            <div className='Custom__Box--FirstStep'>
                <Box padding="500">
                    <div style={{ cursor: 'pointer' }}>
                        <InlineStack align='space-between' blockAlign='center' gap='400'>
                            <div className='skeleton--button'>
                                <SkeletonDisplayText size='small' />
                            </div>
                            <div>
                                <Icon
                                    source={ChevronDownMinor}
                                    tone="base"
                                />
                            </div>
                        </InlineStack>
                    </div>
                </Box>
            </div>
        </BlockStack>
        <BlockStack gap="200">
            <div className='Custom__Box--FirstStep'>
                <Box padding="500">
                    <div style={{ cursor: 'pointer' }}>
                        <InlineStack align='space-between' blockAlign='center' gap='400'>
                            <div className='skeleton--button'>
                                <SkeletonDisplayText size='small' />
                            </div>
                            <div>
                                <Icon
                                    source={ChevronDownMinor}
                                    tone="base"
                                />
                            </div>
                        </InlineStack>
                    </div>
                </Box>
            </div>
        </BlockStack>
    </div>
}

export const KnowledgeBaseCardSkeleton = () => {
    return <Card>
        <BlockStack gap="500">
            <div className='skeleton--textfield'>
                <SkeletonDisplayText />
            </div>
            <SkeletonBodyText lines={20} />
        </BlockStack>
    </Card>

}